import React from 'react';
import PropTypes from 'prop-types';
import {
  View,
  Text,
  ActivityIndicator,
  ScrollView,
  Dimensions,
} from 'react-native';
import { ArcherContainer, ArcherElement } from 'react-archer';

import { translate } from '../../locales/i18n';
import AORTypes from '../../types';
import styles from '../../styles';
import ScrollFading from '../effects/ScrollFading';

class EndpointGraph extends React.Component {
  constructor(props, context) {
    super(props, context);

    console.log(props);
  }

  componentDidUpdate(prevProps) {
    const { content, selectedInput } = this.props;
    if (prevProps.content !== content || prevProps.selectedInput !== selectedInput) {
      // console.log(content, selectedInput);
      this.forceUpdate();
    }
  }

  render() {
    const { endpoint, selectedInput, content } = this.props;

    return (
      <ArcherContainer
        svgContainerStyle={{
          display: 'flex',
          flex: 1,
        }}
      >
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* Inputs */}
          {endpoint.pp.proto?.input.map((input, idx) => (
            <ArcherElement
              key={input.n}
              id={`input${idx + 1}`}
              relations={[
                {
                  targetId: 'process',
                  targetAnchor: 'top',
                  sourceAnchor: 'bottom',
                  style: {
                    strokeColor: styles.primaryColor,
                    strokeWidth: 1,
                  },
                },
              ]}
            >
              <ScrollView
                contentContainerStyle={{
                  alignItems: 'center',
                }}
                style={{
                  maxHeight: Dimensions.get('window').height * 0.20,
                  maxWidth: '80%',
                  overflow: 'scrollY',
                  paddingHorizontal: 6,
                  paddingVertical: 6,
                  backgroundColor: content ? 'white' : styles.primaryColorWithOpacity,
                  borderColor: styles.primaryColor,
                  borderWidth: 1,
                  borderRadius: 8,
                  opacity: selectedInput === idx || selectedInput === -1 ? 1 : 0.2,
                }}
              >
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: styles.primaryFont300,
                    textAlign: 'center',
                    textWrap: 'wrap',
                  }}
                >
                  {(content && content.input && JSON.parse(content.input)[input.n]) || input.d}
                </Text>
              </ScrollView>
            </ArcherElement>
          ))}
        </View>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* Process */}
          <ArcherElement
            id="process"
          >
            <Text
              style={{
                fontSize: 12,
                fontFamily: styles.primaryFont300,
                paddingHorizontal: 18,
                paddingVertical: 6,
                backgroundColor: styles.primaryColor,
                // backgroundColor: (content && content.error) ? '#FE9065' : styles.primaryColor,
                borderColor: styles.primaryColor,
                borderRadius: 8,
                margin: Math.max(15, (Dimensions.get('window').height / 35) - 5),
                textAlign: 'center',
                opacity: selectedInput === -1 ? 1 : 0.15,
              }}
            >
              <b>{endpoint.data.name}</b>
            </Text>
          </ArcherElement>
        </View>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {content && content.error ? (
            <>
              {/* Error */}
              <ArcherElement
                key="error"
                id="error"
                relations={[
                  {
                    targetId: 'process',
                    targetAnchor: 'bottom',
                    sourceAnchor: 'top',
                    style: {
                      strokeColor: 'red',
                      strokeWidth: 1,
                      startMarker: true,
                      endMarker: false,
                    },
                  },
                ]}
              >
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: styles.primaryFont700,
                    paddingHorizontal: 6,
                    paddingVertical: 6,
                    backgroundColor: 'red',
                    borderColor: 'red',
                    borderWidth: 1,
                    borderRadius: 8,
                    margin: 10,
                    textAlign: 'center',
                    color: 'white',
                    maxWidth: '80%',
                  }}
                >
                  {content.errorMessage}
                </Text>
              </ArcherElement>
            </>
          ) : (
            <>
              {/* Output */}
              {endpoint.pp.proto?.output.map((output, idx) => (
                <ArcherElement
                  key={output.n}
                  id={`output${idx + 1}`}
                  relations={[
                    {
                      targetId: 'process',
                      targetAnchor: 'bottom',
                      sourceAnchor: 'top',
                      style: {
                        strokeColor: styles.primaryColor,
                        strokeWidth: 1,
                        startMarker: true,
                        endMarker: false,
                      },
                    },
                  ]}
                >
                  <ScrollView
                    contentContainerStyle={{
                      alignItems: 'center',
                    }}
                    style={{
                      maxHeight: Dimensions.get('window').height * 0.20,
                      maxWidth: '80%',
                      overflow: 'scrollY',
                      paddingHorizontal: 6,
                      paddingVertical: 6,
                      backgroundColor: content ? 'white' : styles.primaryColorWithOpacity,
                      borderColor: styles.primaryColor,
                      borderWidth: 1,
                      borderRadius: 8,
                      opacity: selectedInput === -1 ? 1.0 : 0.2,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: styles.primaryFont300,
                        textAlign: 'center',
                        textWrap: 'wrap',
                      }}
                    >
                      {content
                        ? ((content.output && JSON.parse(content.output)[output.n]) || (
                          <>
                            <ActivityIndicator size="small" color={styles.primaryColor} />
                            <br />
                            {translate('awaiting_response')}
                          </>
                        ))
                        : output.d}
                    </Text>
                  </ScrollView>
                </ArcherElement>
              ))}
            </>
          )}
        </View>
      </ArcherContainer>
    );
  }
}

EndpointGraph.propTypes = {
  endpoint: AORTypes.Endpoint.isRequired,
  selectedInput: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object,
};

EndpointGraph.defaultProps = {
  selectedInput: -1,
  content: undefined,
};

export default EndpointGraph;
